import {useContext} from 'react';
import { createContextProvider } from "../components/store-utils";

export interface MemberPageState {
    total: number
    selected: number[]
}

export type  MemberPageAction =
{type:"setSelected", payload: number[]} |
{type:"setTotal", payload: number} 

function reducer(state:MemberPageState, action:MemberPageAction):MemberPageState{
    switch(action.type){
        case "setSelected": return {...state, selected: action.payload}
        case "setTotal": return {...state, total: action.payload}
    }
}

export const [MemberPageContext, MemberPageStore] = createContextProvider(reducer, {selected:[], total: 0})

export function useIsSelected(){
    const {state: {selected}} = useContext(MemberPageContext);

    return (index:number) =>{
        return selected.includes(index);
    }
}

export function useTotal():[number, number, (t: number) => void]{
    const {state: {total, selected}, dispatch} = useContext(MemberPageContext);

    return [total, selected.length, (total:number) =>{
        dispatch({type: "setTotal", payload: total})
    }]
}

export function useToggle(){
    const isSelected = useIsSelected();
    const {state: {selected}, dispatch} = useContext(MemberPageContext);

    return (index:number) =>{
        const on = isSelected(index);
        if(on) {
            dispatch({type: "setSelected", payload: selected.filter(a => a != index)})
            return;
        }
        dispatch({type: "setSelected", payload: [...selected, index]})
    }
}

export function getRange(begin: number, end: number): number[] {
    const range: number[] = [];
    
    for (let i = begin; i <= end; i++) {
      range.push(i);
    }
  
    return range;
  }